import { useMemo } from 'react'
import { Box } from '@mui/material'
import {
  getPanelHistory,
  useHistoryCustomBack,
  useNavigate,
  usePanelHistoryTop,
} from 'weblite-router'
import { UserRole } from '$logic/profile/types'
import { StaticPanelWappId } from '$logic/wapp-panels'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { NAVIGATION_BAR_HEIGHT } from '$common/navigation-bar'
import { useProfile, useUserIsTeacher } from '$logic/profile/react-hook.ts'
import { HomePanel } from './router-panels/router-panels'
import { VisibilityHandler } from './components/visibility-handler'

export function Workbench() {
  const navigate = useNavigate()

  const homePanelState = usePanelHistoryTop('home')?.state
  const isTop = homePanelState?.tab === 'workbench'
  const profile = useProfile()

  const isTeacher = useUserIsTeacher()
  useHistoryCustomBack(
    () => {
      const panelHistory = getPanelHistory('workbench')
      if (panelHistory.length > 1) navigate(-1)
      else
        HomePanel.navigate('home', {
          replace: true,
          absolute: true,
          data: { tab: 'roomList' },
        })
    },
    [],
    isTop,
  )
  const wapprunnerKey = useMemo(() => {
    const eduProfile = profile?.school
    return eduProfile?.role
  }, [profile])

  return null
  return (
    <VisibilityHandler zIndex={1} considerIOSNotch>
      <Box sx={{ height: `calc(100% - ${NAVIGATION_BAR_HEIGHT}px)` }}>
        <StaticWappPanel
          panelName="workbench"
          wappId={
            isTeacher
              ? StaticPanelWappId.TEACHER_WORKBENCH
              : StaticPanelWappId.STUDENT_WORKBENCH
          }
          input={{}}
          wapprunnerKey={wapprunnerKey}
        />
      </Box>
    </VisibilityHandler>
  )
}
